module.exports = __webpack_public_path__ + "29aeb3f91f4da71e6766492ca2de716d.svg";